import React from 'react';
import { ServiceDetails } from "~/types";
import classes from './style.module.scss';
import useTranslation from "~/app/hooks/useTranslation";

export interface CloseServiceDetailsProps {
  service: ServiceDetails
}

export type CloseServiceDetailsComponent = React.FC<CloseServiceDetailsProps>

const CloseServiceDetails: CloseServiceDetailsComponent = ({ service }) => {
  const { t } = useTranslation("service.closedService");

  return (
    <div className={classes['closed-issue-info']}>
      <div className={classes['title']}>
        {t('title')}
      </div>
      <div className={classes['info']}>
        <div className={classes['time-and-name']}>
          <span className={classes['time']}>{t("closedAt", { date: service.updatedAt })}</span>
          <span className={classes['name']}>{service.serviceUpdatedBy}</span>
        </div>
      </div>
      <hr className={classes['bottom-line']} />
    </div>
  );
};

export default CloseServiceDetails
